var numberFormat = {
  'css': null,

  'exports': {
    setInnerHTML(number) {
        this.root.innerHTML = new Intl.NumberFormat(
            'en-IN', { 
                maximumSignificantDigits: 3 
            }
        ).format(number);
    },

    onMounted(props, state) {
        this.setInnerHTML(props.number);
    },

    onUpdated(props, state) {
        this.setInnerHTML(props.number);
    }
  },

  'template': null,
  'name': 'number-format-tag'
};

export default numberFormat;
